import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { fetchSiteConfig, DEFAULT_SITE_CONFIG } from './services/siteConfigService';
import { I18nProvider } from './i18n';
import ComingSoon from './pages/ComingSoon/ComingSoon.jsx';
import Logo from './pages/Logo/Logo.jsx';
import Home from './pages/Home/Home.jsx';
import Nexus from './pages/Nexus/Nexus.jsx';
import VIP from './pages/VIP/VIP.jsx';
import Conta from './pages/Conta/Conta.jsx';
import Admin from './pages/Admin/Admin.jsx';
import AuthCallback from './pages/AuthCallback/AuthCallback.jsx';
import TermosDeServico from './pages/TermosDeServico/TermosDeServico';
import Error404 from './pages/Error404/Error404';
import Team from './pages/Team/Team.jsx';
import Economia from './pages/Economia/Economia.jsx';
import Download from './pages/Download/Download.jsx';
import ProjetoFinal from './pages/ProjetoFinal/ProjetoFinal.jsx';
import SupportChatNotifier from './components/Admin/SupportChatNotifier.jsx';
import { unlockNotifyBeep } from './utils/notifyBeep';
import useBypassComingSoon from './hooks/useBypassComingSoon';

function PublicRoutes({ pages }) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/nexus" element={pages.nexus ? <Nexus /> : <Error404 />} />
      <Route path="/vip" element={pages.vip ? <VIP /> : <Error404 />} />
      <Route path="/conta" element={pages.conta ? <Conta /> : <Error404 />} />
      <Route path="/equipe" element={pages.team ? <Team /> : <Error404 />} />
      <Route path="/economia" element={pages.economia ? <Economia /> : <Error404 />} />
      <Route path="/download" element={pages.download ? <Download /> : <Error404 />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/termos" element={<TermosDeServico />} />
      <Route path="/logo" element={<Logo />} />
      <Route path="/projeto-final" element={<ProjetoFinal />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

function AppRoutes({ config }) {
  const comingSoon = Boolean(config?.comingSoon);
  const pages = config?.pages || DEFAULT_SITE_CONFIG.pages;
  const { allowed: bypassComingSoon, ready: bypassReady } =
    useBypassComingSoon(comingSoon);

  if (comingSoon && !bypassComingSoon) {
    return (
      <Routes>
        {/* Admin e OAuth continuam acessíveis com o site em "Em breve" */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/projeto-final" element={<ProjetoFinal />} />
        <Route
          path="*"
          element={
            bypassReady ? (
              <ComingSoon />
            ) : (
              <div className="App" aria-busy="true" style={{ minHeight: '100vh' }} />
            )
          }
        />
      </Routes>
    );
  }

  return <PublicRoutes pages={pages} />;
}

function App() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchSiteConfig().then((cfg) => {
      if (alive) setConfig(cfg);
    });

    const onUpdate = (event) => {
      if (event.detail) setConfig(event.detail);
    };
    window.addEventListener('nexus:site-config', onUpdate);

    return () => {
      alive = false;
      window.removeEventListener('nexus:site-config', onUpdate);
    };
  }, []);

  return (
    <I18nProvider>
      <div className="App" onPointerDown={unlockNotifyBeep}>
        <Router>
          <AppRoutes config={config || DEFAULT_SITE_CONFIG} />
          {/* Notificações do Chat VIP em qualquer página (sessão admin) */}
          <SupportChatNotifier />
        </Router>
      </div>
    </I18nProvider>
  );
}

export default App;
